<template>
  <b-card class="border">
    <div class="flex items-center justify-between mb-1">
      <div class="flex items-center gap-3">
        <div
          :class="iconBgClass"
          class="p-1.5 rounded-lg flex items-center justify-center"
        >
          <b-img
            :src="iconCard"
            class="w-[20px] h-[20px]"
          />
        </div>
        <div class="text-[17px] text-[#A0A0A0] font-[400]">
          {{ title }}
        </div>
      </div>

      <MonthFilter
        :month="month"
        @update:month="$emit('update:month', $event)"
        @month-change="$emit('month-change', $event)"
      />
    </div>

    <div class="flex items-center gap-3 mt-2 mb-2">
      <div class="text-2xl text-black font-semibold">
        {{ total }}
      </div>
      <div
        class="rounded-lg px-2 py-0.5 text-[12px] font-medium"
        :class="(percentage || '').includes('-') ? 'bg-[#FEE2E2] text-[#EF4444]' : 'bg-[#DCFCE7] text-[#22C55E]'"
      >
        {{ percentage || '0%' }}
      </div>
    </div>

    <div class="text-[#A0A0A0] text-[12px]">
      {{ description }}
    </div>
  </b-card>
</template>

<script>
import moment from 'moment'
import MonthFilter from './MonthFilter.vue'

export default {
  name: 'GrowthCard',
  components: {
    MonthFilter,
  },
  props: {
    title: { type: String, default: '' },
    iconCard: { type: String, default: '' },
    iconBgClass: { type: String, default: 'bg-[#EBF5FF]' },
    total: { type: [Number, String], default: 0 },
    percentage: { type: String, default: '' },
    description: { type: String, default: '' },
    month: { type: [Object, String, Date], default: () => moment() },
  },
  data() {
    return {
      moment,
    }
  },
}
</script>
